// Single source of truth for the six Sourcing product categories.
//
// The `slug` is what the catalogue_images.category column stores, so the public
// Sourcing page and the admin panel must agree on it. Keep this list and the
// slugs stable — renaming a slug orphans every image already filed under it.
export const CATEGORIES = [
  { slug: "denim-wear", title: "Denim Wear" },
  { slug: "knit-wear", title: "Knit Wear" },
  { slug: "jackets", title: "Jackets" },
  { slug: "home-textiles", title: "Home Textiles" },
  { slug: "raw-fabrics", title: "Raw Fabrics" },
  { slug: "workwear", title: "Workwear" },
];

export const categoryTitle = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.title || slug;

export default CATEGORIES;
